import { tokens } from '@fluentui/react-components';

export const getCopilotResultViewStyles = (components: any, { palette = {} as any }: any) => ({
  loading: {
    backgroundColor: '#f5f9fe',
    paddingTop: '6px',
    paddingBottom: '6px',
  },
  searchResultDropDown: {
    zIndex: '10',
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    borderRadius: '2px',
    borderBottom: 'solid 0.5px',
    borderImage: 'linear-gradient(90deg, #464FEB 35%, #47CFFA 70%, #B47CF8 92%) 1',
  },
  resultHeader: {
    height: '42px',
    width: '100%',
    display: 'flex',
    textAlign: 'left',
    flexDirection: 'row',
    borderWidth: '0px',
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '11px',
    whiteSpace: 'nowrap',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  resultHeaderContainer: {
    backgroundColor: '#f5f9fe',
  },
  resultHeaderIcon: {
    display: 'inline-block',
  },
  copilotIcon: {
    paddingTop: `${tokens.spacingVerticalNone} !important`,
    paddingLeft: `${tokens.spacingHorizontalNone} !important`,
    paddingRight: `${tokens.spacingHorizontalNone} !important`,
  },
  resultHeaderSpan: {
    display: 'inline-block',
    color: '#323130',
    flex: '1 1 1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '8px',
  },
  resultHeaderPlaceholder: {
    display: 'inline-block',
    color: '#616161',
    flex: '1 1 1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '8px',
  },
  resultHeaderLink: {
    fontWeight: 600,
    border: 'none',
    display: 'inline-block',
    background: 'none',
    color: '#115EA3',
    height: '24px',
  },
  resultHeaderHint: {
    height: '42px',
    fontWeight: 600,
    flex: '1 1 1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '8px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    paddingRight: '5px',
  },
  searchResultItem: {
    height: '42px',
    width: '100%',
    textAlign: 'left',
    borderWidth: '0px',
    paddingLeft: '0px',
    paddingRight: '0px',
    backgroundColor: '#f5f9fe',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0)', // Hides the fallback glyph
    '& .iconba.iconba-Forward': {
      marginRight: 4,
    },
  },
  searchItemContainer: {
    height: '42px',
    width: '100%',
    textAlign: 'left',
    borderWidth: '0px',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '8px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    paddingRight: '5px',
    '&:hover': {
      color: palette.themePrimary,
    },
  },
  calloutTargetContainer: {
    width: '100%',
  },
  fallbackGlyph: {
    fontSize: 16,
    float: 'right',
    lineHeight: '19px',
    color: 'inherit',
  },
  searchItemSpan: {
    display: 'inline-block',
    color: '#323130',
    flex: '1 1 1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  searchItemFooterSpan: {
    color: palette.themePrimary,
  },
  shortcutItem: {
    display: 'flex',
    color: palette.neutralSecondary,
    paddingRight: 6,
  },
  shortcutKey: {
    display: 'inline-block',
    border: '1px solid #979797',
    borderRadius: 2,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    width: 14,
    textAlign: 'center',
    '&:first-child': {
      marginRight: 6,
    },
  },
});
